import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class ProfileStatusModal extends Component {

    constructor() {
        super();

        this.state = {
            offlineOptionArray: [
                "Tutoring isn't worth time and money",
                "Askademia website is difficult to use",
                "I am going away, I won't to able to reply to new queries",
                "I am no longer tutoring",
                "I have other reasons",
            ]
        }

    }

    render() {

        const {
            isOpen,
            onHide,
            nextButton,
            selectReason,
            offlineDetails,
            disable 
        } = this.props;

        const { offlineOptionArray } = this.state;
    
        return (

            <Modal
                centered
                size="lg"
                show={isOpen}
                onHide={onHide}
                className="profile-status-modal"
            >
                <Modal.Header>
                    <button onClick={onHide} data-dismiss="modal" aria-label="Close" className="close">
                        <i className="mdi mdi-close"></i>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4>Let us know why you want to go offline</h4>
                    <p>
                        Depending, on your reasons we may have tips to help you continous tutoring 
                        effectivity.
                    </p>
                    <div className="green-radio-custom">
                        {offlineOptionArray.length
                            ? offlineOptionArray.map((question, i) => (
                                <div key={i} className="custom-control custom-radio">
                                    <input
                                        type="radio"
                                        name={`customRadioInline0`}
                                        className="custom-control-input"
                                        id={`customRadioInline${question}`}
                                        defaultChecked={offlineDetails.reasonForLeaving === question}
                                    />
                                    <label
                                        className="custom-control-label"
                                        onClick={() => selectReason(question)}
                                        htmlFor={`customRadioInline${question}`}
                                    >
                                        {question}
                                    </label>
                                </div>
                            )) : ""
                        }
                    </div>
                    <button onClick={nextButton} disabled={disable} className="button">Next</button>
                </Modal.Body>
            </Modal>

        );

    }

}

export default ProfileStatusModal;